import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'goal-setting-failed-modal',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,

    show() {
        this.setState({ show: true });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        return this.promise;
    },

    onClose() {
        this.resolve();
        this.setState({ show: false });
    },

    render() {
        const subjectBid = this.props.subject.get('bid');
        const message = [
            <span key="message-start">Unable to save changes. Please contact </span>,
            <a href="https://www.nwea.org/product-support/" target="_blank" key="product-support-link">
                technical support
                <i key="new-window-icon" className="icon icon-new-window" />
            </a>,
            <span key="message-end"> for help</span>,
        ];
        const buttons = [
            <Button
                key="overwrite-button"
                id={`goal-already-set-overwrite-button-${subjectBid}`}
                bsClass="ok-button btn"
                onClick={this.onClose}
            >
                Close
            </Button>,
        ];

        return (
            <Modal
                id={`goal-already-set-modal-${subjectBid}`}
                bsSize="small"
                aria-labelledby="goal-already-set"
                onHide={this.onClose}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body">{message}</Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
